module.exports = __webpack_public_path__ + "static/media/GPLR.d1db62c7.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/GPLR.JPG
// module id = 1345
// module chunks = 1